import { render, staticRenderFns } from "./HeaderNotifcation.vue?vue&type=template&id=5b7cabdd&scoped=true"
import script from "./HeaderNotifcation.vue?vue&type=script&lang=ts"
export * from "./HeaderNotifcation.vue?vue&type=script&lang=ts"
import style0 from "./HeaderNotifcation.vue?vue&type=style&index=0&id=5b7cabdd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b7cabdd",
  null
  
)

export default component.exports